import React from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-61">
      <div className="max-w-5xl mx-auto" data-id="element-62">
        <div className="text-center mb-6" data-id="element-63">
          <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-64">
            Además recibís estos BONUS
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-600 mb-4" data-id="element-65"></h3>
          <div className="inline-block bg-red-600 text-white text-xl md:text-2xl font-black px-8 py-3 rounded-full shadow-lg animate-bounce" data-id="element-66">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="space-y-6" data-id="element-67">
          {/* Bonus 1 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-68">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-69">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-70">
                <img src="https://cdn.magicpatterns.com/uploads/quSjPBELDQS5K4qcZ5MzgT/6a8f4675-667c-48fe-b82c-49f4d933885e.png" alt="Glosas Listas" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-71" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-72">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-73">
                🎁 BONUS 1 – Glosas Listas
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-74">
                Discursos completos para actos escolares durante todo el año.
              </p>
              <p className="text-lg mb-2" data-id="element-75">Incluye glosas desarrolladas para:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-76">
                <li className="flex items-center" data-id="element-77">
                  <span className="text-blue-500 mr-2" data-id="element-78">•</span> inicio de clases
                </li>
                <li className="flex items-center" data-id="element-79">
                  <span className="text-blue-500 mr-2" data-id="element-80">•</span> fechas patrias
                </li>
                <li className="flex items-center" data-id="element-81">
                  <span className="text-blue-500 mr-2" data-id="element-82">•</span> actos escolares
                </li>
                <li className="flex items-center" data-id="element-83">
                  <span className="text-blue-500 mr-2" data-id="element-84">•</span> cierre de ciclo
                </li>
                <li className="flex items-center" data-id="element-85">
                  <span className="text-blue-500 mr-2" data-id="element-86">•</span> entrega de
                  diplomas
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-87">
                Discursos pensados para emocionar, reflexionar y acompañar cada
                acto escolar.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="flex flex-col md:flex-row-reverse items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-88">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-89">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-90">
                <img src="https://cdn.magicpatterns.com/uploads/vH88y7PoJXM5zR8iYEF95o/4cc8ccb0-28dc-4c8a-b425-ccbe06d414ae.png" alt="Actos Resueltos" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-91" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-92">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-93">
                🎁 BONUS 2 – Actos Resueltos
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-94">
                Organizá los actos escolares sin empezar desde cero.
              </p>
              <p className="text-lg mb-2" data-id="element-95">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-96">
                <li className="flex items-center" data-id="element-97">
                  <span className="text-blue-500 mr-2" data-id="element-98">•</span> estructura
                  completa de actos escolares
                </li>
                <li className="flex items-center" data-id="element-99">
                  <span className="text-blue-500 mr-2" data-id="element-100">•</span> orden de
                  participación
                </li>
                <li className="flex items-center" data-id="element-101">
                  <span className="text-blue-500 mr-2" data-id="element-102">•</span> ideas para
                  conducir actos
                </li>
                <li className="flex items-center" data-id="element-103">
                  <span className="text-blue-500 mr-2" data-id="element-104">•</span> organización de
                  ceremonias escolares
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-105">
                Un material que te permite organizar actos escolares de forma
                rápida y clara.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="flex flex-col md:flex-row items-center gap-5 bg-gray-50 rounded-3xl p-5 border border-gray-200" data-id="element-106">
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-107">
              <a href="#compra" className="cursor-pointer hover:scale-105 transition-transform" data-id="element-108">
                <img src="https://cdn.magicpatterns.com/uploads/sLTrEExPsYGMJZfGLwEgaQ/443e7edd-d3c4-408d-9ff1-bb6e23a20f4f.png" alt="Pack Mundial" className="w-[400px] h-[400px] object-contain drop-shadow-xl" data-id="element-109" />
              </a>
            </div>
            <div className="w-full md:w-1/2" data-id="element-110">
              <h3 className="text-3xl font-black mb-2 text-blue-600" data-id="element-111">
                🎁 BONUS 3 – Pack Mundial
              </h3>
              <p className="text-xl font-bold mb-2" data-id="element-112">
                Actividades listas para trabajar el Mundial 2026 en clase o en
                casa.
              </p>
              <p className="text-lg mb-2" data-id="element-113">Incluye:</p>
              <ul className="space-y-1 text-lg mb-3 pl-4" data-id="element-114">
                <li className="flex items-center" data-id="element-115">
                  <span className="mr-2" data-id="element-116">⚽</span> fichas educativas
                </li>
                <li className="flex items-center" data-id="element-117">
                  <span className="mr-2" data-id="element-118">⚽</span> sopas de letras
                </li>
                <li className="flex items-center" data-id="element-119">
                  <span className="mr-2" data-id="element-120">⚽</span> juegos temáticos
                </li>
                <li className="flex items-center" data-id="element-121">
                  <span className="mr-2" data-id="element-122">⚽</span> actividades del Mundial
                </li>
                <li className="flex items-center" data-id="element-123">
                  <span className="mr-2" data-id="element-124">⚽</span> propuestas educativas para el
                  aula
                </li>
              </ul>
              <p className="text-lg font-medium italic p-2 rounded-lg bg-[#F9FAFB]" data-id="element-125">
                Ideal para aprovechar el Mundial como recurso educativo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}